module.exports = __webpack_public_path__ + "static/videos/etch_005.30df631.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_005.mp4
// module id = 467
// module chunks = 1